import { render, staticRenderFns } from "./ModalBattlesModes.vue?vue&type=template&id=df2392b6&scoped=true"
import script from "./ModalBattlesModes.vue?vue&type=script&lang=js"
export * from "./ModalBattlesModes.vue?vue&type=script&lang=js"
import style0 from "./ModalBattlesModes.vue?vue&type=style&index=0&id=df2392b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2392b6",
  null
  
)

export default component.exports